import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { isFreeMode } from "@/lobby_common/utils/utils.js"
import { divideAccuracy, formatLang } from "@/lobby_common/utils/utils.js";
export default {
  name: "ExperienceWallet",
  components: {
  },
  props: {
    experienceObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      divideAccuracy, formatLang,
      isFreeMode,
      surplusTime: undefined,
      surplusTxt: undefined,
      timer: null,
      PopupWindowShow: false,
    };
  },
  computed: {
    
  },
  created() {
  },
  mounted() {},
  watch: {
    experienceObj: {
      handler: function (value) {
        this.surplusTime = this.experienceObj.experienceTime
        if (this.surplusTime && this.surplusTime > 0) {
          this.getTime()
        }
      },
      immediate: true,
    },
  },
  destroyed() {},
  methods: {
    // 倒计时
    getTime() {
      // 美东 -4时间
      // const _this = this
      if (this.timer === null) {
        this.timer = setInterval(() => {
          this.surplusTime = this.surplusTime - 1;
          if (!this.surplusTime || this.surplusTime < 0) {
            clearInterval(this.timer);
            this.timer = null;
            this.$store.dispatch("getUserCoinsAsync")
            return false
          }
          this.down(Math.floor(this.surplusTime));
        }, 1000);
      }
    },
    down(time) {
      let h = Math.floor(time / 3600);
      let m = Math.floor((time - h * 3600) / 60);
      let s = time % 60;
      h = h > 9 ? h : "0" + h;
      m = m > 9 ? m : "0" + m;
      s = s > 9 ? s : "0" + s;
      this.surplusTxt = h + ":" + m + ":" + s;
    },
    clickFun() {
      this.PopupWindowShow = false;
      const jump = {
        type: "Jump_TYPE_FUNCTION",
        functionType: "JUMP_FUNCTION_TYPE_RECHARGE",
      };
      goJoinEvent(jump);
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
